import { RootElmActionReturnType, sendLocalAction } from 'actions/service/rootElmAction';

export interface FunctionTypes {
  addServerWithName(name: string): RootElmActionReturnType;
  removeServerWithName(name: string): RootElmActionReturnType;
}

export function addServerWithName(name: string) {
  return sendLocalAction('addServerWithName', { name });
}

export function removeServerWithName(name: string) {
  return sendLocalAction('removeServerWithName', { name });
}
